// eslint-disable-next-line import/no-cycle
import { ComponentNameEnum, DropdownOption } from '@/types';

const getCodeFieldConfig = (
  defaultValue = '',
  displayVariables = false,
  variablesList: DropdownOption[] = [],
  displayConditionalButton = false,
  mode = 'text/html',
) => ({
  componentName: ComponentNameEnum.CODE,
  options: {
    defaultValue,
    variablesList,
    displayVariables,
    displayConditionalButton,
    mode,
  },
});

export default getCodeFieldConfig;
